<script setup lang="ts">
import { Mail } from 'lucide-vue-next'
</script>

<template>
  <section class="bg-white rounded-2xl shadow-sm p-6">
    <h4 class="font-semibold text-gray-900 mb-4">Need Help?</h4>
    <div class="space-y-3">
      <a
        href="mailto:support@bindle.co.uk"
        class="w-full bg-gray-100 text-gray-700 py-3 rounded-xl hover:bg-gray-200 transition-colors flex items-center justify-center text-sm font-medium"
      >
        <Mail class="w-4 h-4 mr-2" />
        Email: support@bindle.co.uk
      </a>
    </div>
  </section>
</template>
